module.exports = __webpack_public_path__ + "img/sad.3c84948b.png";